import { render, staticRenderFns } from "./moving_up_class.vue?vue&type=template&id=213880c0&scoped=true&"
import script from "./moving_up_class.vue?vue&type=script&lang=js&"
export * from "./moving_up_class.vue?vue&type=script&lang=js&"
import style0 from "./moving_up_class.vue?vue&type=style&index=0&id=213880c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213880c0",
  null
  
)

export default component.exports